import React, { useEffect, useState } from 'react';

import Modal from 'react-bootstrap/Modal';

import Table from '../Table/Table';

import { loadClientDocument } from '../Api/Api';

export default function DVModal({ show, handleClose, client_ID, userName }) {
  const $ = require('jquery');

  const [docDaysBefore] = useState(365);
  const [documents, setDocumentsData] = useState([]);

  const filteredCompliances = documents.filter(
    (row) => row.document_status !== 'RESOLVIDO'
  );

  const columns = [
    {
      title: 'Documento',
      data: 'document_name',
      className: 'text-center align-middle',
      createdCell: function (cell, cellData, rowData) {
        if (rowData.document_type_id == '3') {
          $(cell).addClass('criticals');
        }
      },
    },
    {
      title: 'Emissão',
      data: 'document_emitted',
      className: 'text-center align-middle',
    },
    {
      title: 'Validade',
      data: 'document_expiration',
      className: 'text-center align-middle',
    },
    {
      title: 'Dias restantes',
      data: 'valid_days',
      className: 'text-center align-middle',
      render: function (data, type, row) {
        let badgeClass = '';
        let badgeContent = '';

        if (row.valid_days <= 3) {
          badgeClass = 'badge bg-danger blink_me';
        } else if (row.valid_days > 3 && row.valid_days <= 15) {
          badgeClass = 'badge bg-danger';
        } else if (row.valid_days > 15 && row.valid_days <= 45) {
          badgeClass = 'badge bg-warning';
        } else if (row.valid_days > 45) {
          badgeClass = 'badge bg-info';
        }

        badgeContent =
          Math.sign(row.valid_days) === -1
            ? 'Vencido'
            : row.valid_days + ' dia(s)';

        return `<span class="${badgeClass}">${badgeContent}</span>`;
      },
    },
    {
      title: 'Status',
      data: 'document_status',
      className: 'text-center align-middle',
      render: function (data, type, row) {
        let statusColor = 'badge bg-secondary';
        let statusName = 'N/A';

        if (row.document_status == 'RESOLVIDO') {
          statusColor = 'badge bg-success';
          statusName = 'Resolvido';
          return null; //oculta os resolvidos
        } else if (row.document_status == 'EM TRATATIVA') {
          statusColor = ' badge bg-warning text-dark';
          statusName = 'Em tratativa';
        }

        return `<span class="${statusColor}">${statusName}</span>`;
      },
    },
  ];

  const hide = () => {
    handleClose();
  };

  const loadClientDoc = async (daysBefore) => {
    const res = await loadClientDocument(client_ID, daysBefore);
    if (res) {
      setDocumentsData(res.data);
    }
  };

  useEffect(() => {
    loadClientDoc(docDaysBefore);
  }, [client_ID]);

  return (
    <>
      <Modal size="lg" show={show} onHide={hide}>
        <Modal.Header closeButton>
          <Modal.Title>{userName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12">
            <div className="card recent-sales">
              <div className="card-header">
                <b>Documentos a vencer</b> | próximos {docDaysBefore} dias
              </div>
              <div className="card-body scrollBase">
                <Table data={filteredCompliances} columns={columns} />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
